import clsx from 'clsx';
import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon';
import { Skeleton } from './Skeleton';
import styles from './StatTile.module.css';

export interface StatTileProps {
  label: string;
  value: ReactNode;
  unit?: string;
  caption?: ReactNode;
  icon?: IconName;
  mono?: boolean;
  loading?: boolean;
  className?: string;
}

export function StatTile({
  label,
  value,
  unit,
  caption,
  icon,
  mono = false,
  loading = false,
  className,
}: StatTileProps) {
  return (
    <div className={clsx(styles.tile, className)}>
      <div className={styles.head}>
        {icon ? <Icon name={icon} size={14} /> : null}
        <span className={styles.label}>{label}</span>
      </div>

      {loading ? (
        <Skeleton width="60%" height={28} />
      ) : (
        <div className={clsx(styles.value, mono && styles.valueMono)}>
          {value}
          {unit ? <span className={styles.unit}>{unit}</span> : null}
        </div>
      )}

      {caption ? <div className={styles.caption}>{loading ? <Skeleton width="40%" text /> : caption}</div> : null}
    </div>
  );
}
